<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  darkMode: boolean
  isSelected: boolean
}>()

const svgClasses = computed<string[]>(() => {
  return [props.darkMode ? 'is-dark' : 'is-light', props.isSelected ? 'is-selected' : '']
})
</script>

<template>
  <svg width="48" height="24" viewBox="0 0 48 24" xmlns="http://www.w3.org/2000/svg" :class="svgClasses">
    <g>
      <path d="M14.5 11L14.5 13" class="path-stroke" stroke-width="2.2" stroke-linecap="round" />
      <path d="M23 19.5L21 19.5" class="path-stroke" stroke-width="2.2" stroke-linecap="round" />
      <path d="M29 19.5L27 19.5" class="path-stroke" stroke-width="2.2" stroke-linecap="round" />
      <path d="M23 4.5L21 4.5" class="path-stroke" stroke-width="2.2" stroke-linecap="round" />
      <path d="M29 4.5L27 4.5" class="path-stroke" stroke-width="2.2" stroke-linecap="round" />
      <path
        d="M30.1835 10.7772C30.0642 10.8437 29.9763 10.9565 29.938 11.0922C29.8998 11.228 29.9141 11.3762 29.978 11.5063L35.1258 21.972C35.1727 22.0674 35.2441 22.1484 35.3317 22.2057C35.4193 22.2629 35.5195 22.2941 35.6209 22.2956C35.7223 22.2971 35.8206 22.2688 35.9047 22.2141C35.9887 22.1593 36.055 22.0803 36.0959 21.9862L37.2125 19.4134L40.9396 22.7172C41.0506 22.8154 41.1926 22.8657 41.3345 22.857C41.4764 22.8484 41.6065 22.7814 41.6962 22.6709L43.0508 21.0023C43.1404 20.8917 43.1823 20.7466 43.1672 20.5989C43.1522 20.4512 43.0814 20.313 42.9705 20.2147L39.287 16.9493L41.6445 15.4072C41.7295 15.3516 41.7962 15.2712 41.8367 15.1754C41.8772 15.0796 41.8899 14.9725 41.8733 14.8667C41.8566 14.7609 41.8113 14.6608 41.7427 14.5783C41.674 14.4958 41.585 14.4343 41.486 14.401L30.5989 10.7415C30.5295 10.7183 30.4571 10.7094 30.3857 10.7155C30.3144 10.7216 30.2456 10.7426 30.1835 10.7772Z"
        class="path-fill"
      />
      <rect x="12" y="2" width="5" height="5" rx="1" class="path-stroke path-fill-invert" stroke-width="2.2" />
      <rect x="33" y="2" width="5" height="5" rx="1" class="path-stroke path-fill-invert" stroke-width="2.2" />
      <rect x="12" y="17" width="5" height="5" rx="1" class="path-stroke path-fill-invert" stroke-width="2.2" />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.is-light {
  .path-stroke {
    @apply stroke-dark-text-200;
  }

  .path-fill {
    @apply fill-dark-text-200;
  }

  .path-fill-invert {
    @apply fill-light-text-200;
  }
}

.is-dark {
  .path-stroke {
    @apply stroke-light-text-200;
  }

  .path-fill {
    @apply fill-light-text-200;
  }

  .path-fill-invert {
    @apply fill-dark-text-200;
  }
}

@mixin path-dark-text-100 {
  .path-stroke {
    @apply stroke-dark-text-100;
  }

  .path-fill {
    @apply fill-dark-text-100;
  }

  .path-fill-invert {
    @apply fill-light-text-100;
  }
}

@mixin path-light-text-100 {
  .path-stroke {
    @apply stroke-light-text-100;
  }

  .path-fill {
    @apply fill-light-text-100;
  }

  .path-fill-invert {
    @apply fill-dark-text-100;
  }
}

.is-selected {
  &.is-light {
    @include path-dark-text-100;
  }

  &.is-dark {
    @include path-light-text-100;
  }
}

@media (hover: hover) {
  .group:hover {
    .is-light {
      @include path-dark-text-100;
    }

    .is-dark {
      @include path-light-text-100;
    }
  }
}
</style>
